<template>
  <div class="app-list">
    <div class="details box">
      <h3>
        汇总数据
        <div class="dateRange">
          <span class="label">时间范围:</span>
          {{ summaryMsg.date }}
        </div>
      </h3>
      <ul>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>总流水</span>
          </p>
          <p class="number">￥{{ summaryMsg.income }}</p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>商家收益</span>
          </p>
          <p class="number">￥{{ summaryMsg.business_gain }}</p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>代理收益</span>
          </p>
          <p class="number">￥{{ summaryMsg.proxy_gain }}</p>
        </li>
        <li>
          <p class="name">
            <Icon type="ios-cash" />
            <span>平台收益</span>
          </p>
          <p class="number">￥{{ summaryMsg.pt_gain }}</p>
        </li>
      </ul>
    </div>
    <Card title="财务报表" class="demo-tabs-style2">
      <div class="searchBox">
        <Form label-position="left" inline :model="searchForm">
          <FormItem :label-width="70" label="汇总时间">
            <DatePicker
              :editable="false"
              format="yyyy-MM-dd"
              v-model="dateRange"
              type="daterange"
              :options="options2"
              placement="bottom-end"
              placeholder="请选择日期"
              style="width: 200px"
              @on-change="getDateArrage"
            ></DatePicker>
          </FormItem>
          <FormItem style="margin-left: 60px" :label-width="70" label="商家名称">
            <Input v-model="searchForm.username" class="input" clearable placeholder="输入商家名称" />
          </FormItem>
          <FormItem style="margin-left: 60px">
            <Button type="primary" icon="ios-search" @click="onSearch">搜索</Button>
          </FormItem>
        </Form>
      </div>

      <div class="content">
        <Table
          tooltip-theme="light"
          max-height="1000"
          highlight-row
          :loading="loading"
          :columns="columns"
          :data="data"
        >
          <template slot-scope="{ row, index }" slot="action">
            <Poptip transfer title="二维码" placement="top-end">
              <Button
                type="primary"
                size="small"
                style="margin-right: 5px"
                @click="application(row, index)"
              >预览</Button>
              <div slot="title" class="poptipTitle">
                <span>二维码</span>
                <Button target="_blank" :to="row.link" type="text">链接</Button>
              </div>
              <div slot="content">
                <img class="QRcodeImg" :src="row.QRcode" alt="二维码" srcset />
              </div>
            </Poptip>
          </template>
        </Table>
      </div>
      <div class="pageBox cardBox" v-if="false">
        <Page :current="current" :total="total" :page-size="limit" simple />
      </div>
    </Card>
  </div>
</template>

<script>
import axios from "axios";
import { financeReport } from "@/service/api";

export default {
  components: {},
  data() {
    return {
      loading: false,
      summaryMsg: {},
      total: 0,
      current: 1,
      limit: 15,
      searchForm: {},
      dateRange: [],
      columns: [
        {
          title: "日期",
          key: "date",
          sortable: true,
          width: 200,
        },
        {
          title: "总流水",
          key: "income",
          sortable: true,
          width: 200,
        },
        {
          title: "商家收益",
          key: "business_gain",
          sortable: true,
          width: 200,
        },
        {
          title: "代理收益",
          key: "proxy_gain",
          sortable: true,
          width: 200,
        },
        {
          title: "平台收益",
          key: "pt_gain",
          sortable: true,
          width: 200,
        },
        // {
        // 	title: '操作',
        // 	key: 'menu',
        // 	slot: 'action',
        // 	fixed: 'right',
        // 	width: 80
        // }
      ],
      data: [],
      options2: {
        shortcuts: [
          {
            text: "一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
          {
            text: "六个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              return [start, end];
            },
          },
          {
            text: "一年",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              return [start, end];
            },
          },
        ],
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
    };
  },
  mounted() {
    console.log(this.$route.query.merchant);
    let merchant = this.$route.query.merchant;
    if (merchant) {
      this.searchForm.username = merchant;
    }
    this.getData();
  },
  watch: {},
  methods: {
    getDateArrage(val) {
      console.log(val);
      this.searchForm.start_day = val[0];
      this.searchForm.end_day = val[1];
    },
    getData() {
      this.loading = true;
      let params = Object.assign(this.searchForm, {
        page: this.current,
        limit: this.limit,
        invite: window.sessionStorage.getItem("inviteCode"),
      });
      console.log(this.searchForm, ">>>>");
      financeReport(params)
        .then((res) => {
          this.loading = false;

          console.log("res:", res);
          if (res.data.code == 0) {
            let data = res.data.data;
            this.total = data.count;
            this.summaryMsg = data.collect_data;
            this.data = data.union_list.map((item) => {
              return {
                date: item.date,
                income: item.income,
                business_gain: item.business_gain,
                proxy_gain: item.proxy_gain,
                pt_gain: item.pt_gain,
              };
            });
          } else {
            this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg || "操作失败！",
            });
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    onSearch() {
      this.current = 1;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.app-list {
  flex: 1;
  margin-top: 30px;
  height: max-content;
  > .content {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    width: 100%;
    box-sizing: border-box;
  }
  .dateRange {
    float: right;
    .label {
      color: #9a9a9a;
      font-size: 14px;
    }
  }
  .pageBox {
    padding: 10px 0;
    margin-top: 2px;
  }

  .searchBox {
    padding: 20px 0;
    .input {
      width: 200px;
    }
  }
  .box {
    margin-bottom: 30px;
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    padding: 25px;
  }
  .details {
    ul {
      padding: 30px;
      display: flex;
      justify-content: space-around;
    }

    li {
      flex: 1;
      text-align: center;
      .name {
        color: #9a9a9a;
        .ivu-icon {
          font-size: 26px;
          margin-right: 6px;
          vertical-align: middle;
        }
      }

      .number {
        color: #f47d01;
        font-size: 36px;
        font-weight: 600;
        margin: 30px auto;
      }
    }
  }
}

.poptipTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.QRcodeImg {
  width: 250px;
  height: 250px;
  object-fit: cover;
}
</style>
<style>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #fff;
}

.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  border-top: 1px solid #f47d01;
}

.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #f47d01;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
